import { render, staticRenderFns } from "./JWGeofencing.vue?vue&type=template&id=0c250244&"
import script from "./JWGeofencing.vue?vue&type=script&lang=js&"
export * from "./JWGeofencing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports